import React, { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

const DisableTextSelectionWrapper: React.FC<
  IProps
> = ({ children }) => {
  return (
    <div
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
      }}
    >
      {children}
    </div>
  );
};

export default DisableTextSelectionWrapper;
